import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookApiService {

  constructor(
    private http: HttpClient,
  ) { }

  getBookDetails(bookcode: string | null): Observable<any> {
    return this.http.get(`${environment.URL_API_AV}/api/doctrine/web/${bookcode}/details`);
  }

  getFile(payload: any): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.URL_API_AV}/api/files/book/resources`, payload, { responseType: 'blob' })
    );
  }

  addWishlist(payload: any): Observable<any> {
    return this.http.post(`${environment.URL_API_AV}/api/user/me/wishlist`, payload);
  }

  getWishlistVerify(bookcode: string | null): Observable<any> {
    return this.http.get(`${environment.URL_API_AV}/api/user/me/wishlist/verify/${bookcode}`);
  }

}
